import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Select from 'react-select';
import ApiService from '../../services/apiService';
import { toast } from 'react-toastify';
import { setRows, addRow, removeRow, removeSingleRow, updateRow, clearRows } from '../../../Redux/actions/rowActions';
import { IoAddSharp } from "react-icons/io5";
import { RxCross1 } from "react-icons/rx";
import AsyncSelect from 'react-select/async';

const RequisitionGrid = ({ onRequisitionData, itemData, selectedLocation, precision }) => {
    const rows = useSelector(state => state.rows.rows);
    const dispatch = useDispatch();
    const [itemOptions, setItemOptions] = useState([]);
    const [itemRows, setItemRows] = useState([]);
    const [descriptionOptions, setDescriptionOptions] = useState([]);
    const apiService = new ApiService();
    const initialMount = useRef(true);
    const [page, setPage] = useState(1);
    const [desPage, setDecPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loader, setLoaders] = useState(false);

    useEffect(() => {
        const getItems = async () => {
            try {
                if (initialMount.current && itemData?.prDetails && itemData.prDetails.length > 0) {
                    const formattedRowsitm = itemData?.prDetails.map(async (detail, index) => {
                        const selecteditms = await apiService.getApiParamater("GET_ITEM", `?ItemNo=${detail.itemCode}`);
                        let selecteditem = selecteditms?.data?.result[0]

                        return {
                            requisitionNo: detail.requisitionNo,
                            srno: detail.srno,
                            itemNo: detail.itemCode,
                            recordId: detail.itemCode,
                            itemDescription: detail.itemDescription,
                            branch: '',
                            qty: detail.qty,
                            uom: detail.uom,
                            baseQty: selecteditem.convToInvUOM * detail.qty,
                            convRate: selecteditem.convToInvUOM,
                            baseAmount: detail?.unitPrice?.toFixed(precision || 0) || 0,
                            specification: detail.specification,
                            amount: detail?.amount?.toFixed(precision || 0),
                            stock: selecteditem?.stock / selecteditem.convToInvUOM,
                            bol: ''
                        };
                    }).filter(row => row !== null);
                    const formattedRows = await Promise.all(formattedRowsitm);
                    if (formattedRows.length > 0) {
                        dispatch(setRows(formattedRows));
                        setItemRows(formattedRows);
                        onRequisitionData(formattedRows);
                    }
                }
            } catch (error) {
                console.error('Error fetching items:', error);
            }
        };
        if (itemData) {
            getItems();
        }
    }, [itemData, dispatch]);
    useEffect(() => {
        if (initialMount.current) {
            initialMount.current = false;
        } else {
            itemRows.forEach((row, index) => {
                dispatch(updateRow(index, row));
            });
        }
    }, [itemRows, dispatch]);
    useEffect(() => {
        onRequisitionData(rows);
    }, [rows]);

    useEffect(() => {
        fetchItemNo("", 1);
        fetchItemDesc("", 1);
    }, []);

    useEffect(() => {
        if (rows[0]?.itemNo && selectedLocation?.label) {
            updateRowsWithNewStock();
        }
    }, [selectedLocation]);

    const fetchItemNo = async (inputValue = "", pageNumber = 1) => {
        if (loader) return;
        setLoaders(true);
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', pageNumber || 1);
            params.append('PageSize', 20);
            params.append('ItemNo', inputValue || '');
            const response = await apiService.getApiParamater('GET_ITEM', `?${params.toString()}`);
            const fetchedItems = response.data.result.map(item => ({
                label: item.itemNo,
                value: item,
            }));
            if (fetchedItems.length < 20) setHasMore(false);
            setItemOptions(prevAccounts => [...prevAccounts, ...fetchedItems]);
            setLoaders(false);
            return fetchedItems;
        } catch (error) {
            console.error("Error fetching account data:", error);
            setLoaders(false);
            return [];
        }
    };
    const fetchItemDesc = async (inputValue = "", pageNumber = 1) => {
        if (loader) return;
        setLoaders(true);
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', pageNumber || 1);
            params.append('PageSize', 20);
            params.append('ItemDescription', inputValue || '');
            const response = await apiService.getApiParamater('GET_ITEM', `?${params.toString()}`);
            const fetchedItems = response.data.result.map(item => ({
                label: item.itemDescription,
                value: item,
            }));
            if (fetchedItems.length < 20) setHasMore(false);
            setDescriptionOptions(prevAccounts => [...prevAccounts, ...fetchedItems]);
            setLoaders(false);
            return fetchedItems;
        } catch (error) {
            console.error("Error fetching account data:", error);
            setLoaders(false);
            return [];
        }
    };
    const loadOptions = async (inputValue, callback) => {
        const options = await fetchItemNo(inputValue, 1);
        callback(options);
    };
    const loadDescOptions = async (inputValue, callback) => {
        const options = await fetchItemDesc(inputValue, 1);
        callback(options);
    };
    const loadMoreOptions = async () => {
        if (!hasMore || loader) return;
        setPage(prevPage => prevPage + 1);
        await fetchItemNo("", page + 1);
    };
    const loadMoreDescOptions = async () => {
        if (!hasMore || loader) return;
        setDecPage(prevPage => prevPage + 1);
        await fetchItemDesc("", desPage + 1);
    };
    const handleInputChange = async (index, fieldName, value) => {
        try {

            const DB = localStorage.getItem('DataBase');
            const companies = JSON.parse(localStorage.getItem('UserCompanies') || '[]');
            const defaultCompany = companies.find(comp => comp.dataDB === DB);
            const companyName = defaultCompany?.companyName?.toUpperCase() || '';
            const isYusuf = companyName.includes("KANOO") || companyName.includes("ACCOUNTCODE");

            if (isYusuf === false) {
                const isDuplicate = rows.some((row, rowIndex) => rowIndex !== index && (row.itemNo === value || row.itemDescription === value));
                if (isDuplicate) {
                    toast.error('Please choose a different item.');
                    return;
                }
            }

            if (selectedLocation.length === 0) {
                toast.warning("Select Location")
                return;
            }
            const updatedRows = [...rows];
            const updatedRow = { ...updatedRows[index], [fieldName]: value, srno: ("0" + (index + 1)).slice(-2) };
            if (fieldName === 'itemNo' || fieldName === 'itemDescription') {

                const selectedItm = fieldName === 'itemNo' ? itemOptions?.find(dep => dep?.label === value) : descriptionOptions?.find(dep => dep?.label === value);
                const queryParam = `itemNo=${selectedItm?.value?.itemNo}`
                const selecteditmstock = await apiService.getApiParamater('GET_ITEM', `?isActive=true&Warehouse=${selectedLocation.label}&${queryParam}`);
                let selectedItem = selecteditmstock?.data?.result?.[0]

                if (selectedItem) {
                    updatedRow.itemDescription = selectedItem.itemDescription;
                    updatedRow.requisitionNo = selectedItem.itemDescription;
                    updatedRow.uom = selectedItem.baseUnit;
                    updatedRow.itemNo = selectedItem.itemNo;
                    updatedRow.specification = selectedItem.specification;
                    updatedRow.convRate = selectedItem.convToInvUOM;
                    updatedRow.baseQty = 0;
                    updatedRow.stock = (selectedItem?.stock / selectedItem.convToInvUOM).toFixed(precision || 0) || 0;
                    updatedRow.supplierId = selectedItem?.supplier;
                    updatedRow.baseAmount = selectedItem?.avgPrice?.toFixed(precision || 0) || 0
                }
            }
            if (fieldName === 'qty') {
                const quantity = parseFloat(value);
                const convToInvUOM = updatedRow.convRate;
                if (quantity < 0) {
                    toast.warning("Enter Quantity greater then 0")
                    return
                } else {
                    const baseQty = convToInvUOM ? parseFloat(convToInvUOM) : 1;
                    updatedRow.baseQty = (!isNaN(quantity) && quantity !== 0) ? (quantity * baseQty) : 0;
                }
            }
            if (fieldName === 'qty' || fieldName === 'baseAmount') {
                const unitPrice = parseFloat(updatedRow?.baseAmount);
                if (unitPrice < 0) {
                    toast.warning("Enter Unit Price greater then 0")
                    return
                } else {
                    const quantity = parseFloat(updatedRow.qty);
                    updatedRow.amount = (!isNaN(quantity) && !isNaN(unitPrice)) ? (unitPrice * quantity).toFixed(precision || 0) : 0;
                }
            }
            updatedRows[index] = updatedRow;
            dispatch(setRows(updatedRows));
            setItemRows(updatedRows);
            onRequisitionData(updatedRows);
        } catch (error) {
            console.error('Error handling input change:', error);
        }
    };
    const addNewRow = () => {
        const newRow = {
            srno: '',
            itemNo: '',
            requisitionNo: '',
            itemDescription: '',
            branch: '',
            qty: '',
            uom: '',
            baseQty: '',
            convRate: '',
            baseAmount: '',
            amount: '',
            stock: '',
            bol: '',
            recordId: '',
            specification: '',
            supplierId: '',
        };
        dispatch(addRow(newRow));
        const updatedRows = [...rows, newRow];
        setItemRows(updatedRows);
        onRequisitionData(updatedRows);
        dispatch(setRows(updatedRows));
    };
    const handleRemoveRow = (index) => {
        dispatch(removeSingleRow(index));
        const updatedRows = rows
            .filter((_, i) => i !== index)
            .map((row, i) => ({
                ...row,
                srno: i + 1
            }));
        onRequisitionData(updatedRows);
        setItemRows(updatedRows)
        dispatch(setRows(updatedRows));

    };
    const updateRowsWithNewStock = async () => {
        try {
            const updatedRows = rows.map(row => ({ ...row }));

            const apiPromises = updatedRows.map(async (row, index) => {
                const queryParam = `itemNo=${row.itemNo}`;
                const response = await apiService.getApiParamater(
                    'GET_ITEM',
                    `?Warehouse=${selectedLocation.label}&${queryParam}`
                );

                if (response?.data?.statusCode === 200) {
                    const itemData = response.data.result[0];
                    updatedRows[index].stock = itemData.stock / itemData?.convToInvUOM || 0;
                    updatedRows[index].stockType = itemData.stockType || "---";
                    updatedRows[index].itemNo = itemData.itemNo;
                    updatedRows[index].itemDescription = itemData.itemDescription;
                    updatedRows[index].uom = itemData.baseUnit;
                    updatedRows[index].supplierId = itemData.supplier;
                    updatedRows[index].baseQty = parseFloat(itemData.convToInvUOM);
                } else if (response?.data?.statusCode === 204) {
                    updatedRows[index] = {
                        ...row,
                        stock: 0,
                    };
                }
            });
            await Promise.all(apiPromises);
            dispatch(setRows(updatedRows));
            setItemRows(updatedRows);
            onRequisitionData(updatedRows);
        } catch (error) {
            console.error('Error updating rows with new stock:', error);
        }
    }
    const preventNegativeSign = (e) => {
        if (e.key === "-" || e.key === "+") {
            e.preventDefault();
        }
    };
    return (
        <div className='table-container p-2 mb-5' style={{ overflowX: 'auto', height: "400px" }}>
            <table>
                <thead className='dynoTable'>
                    <tr>
                        <th></th>
                        <th>Sr no</th>
                        <th>Item No</th>
                        <th>Description</th>
                        <th>Item Specs</th>
                        <th>Qty</th>
                        <th>Packing UOM</th>
                        <th>Inventory Qty</th>
                        <th>Unit Price</th>
                        <th>Amount</th>
                        <th>Stock</th>
                        <th>BalForPo</th>
                    </tr>
                </thead>
                <tbody>
                    {Array.isArray(itemRows) && rows?.map((row, index) => (
                        <tr key={index}>
                            {itemData?.eye ?
                                <td className='m-0 p-0' style={{ border: "1px solid rgba(118, 118, 118, 0.3)", cursor: "not-allowed" }}>
                                    <div className='center'>
                                        <RxCross1 size={25} disabled />
                                    </div>
                                </td> :
                                <td className='m-0 p-0' style={{ border: "1px solid rgba(118, 118, 118, 0.3)" }}>
                                    <div onClick={() => handleRemoveRow(index)} className='center'>
                                        <RxCross1 size={25} />
                                    </div>
                                </td>
                            }
                            <td className='m-0 p-0'><input className='p-2' type="text" style={{ width: "80px" }} value={row.srno} disabled /></td>
                            <td className='m-0 p-0 itemCol'>
                                {itemData?.eye ?
                                    <input className='p-2' type='text' disabled value={row?.itemNo} />
                                    :
                                    <AsyncSelect
                                        cacheOptions
                                        value={{ value: row.itemNo, label: row.itemNo }}
                                        options={itemOptions}
                                        loadOptions={loadOptions}
                                        onChange={selectedOption => handleInputChange(index, 'itemNo', selectedOption.label)}
                                        defaultOptions={itemOptions}
                                        onMenuScrollToBottom={loadMoreOptions}
                                        className="descSelect"
                                        classNamePrefix="descSelect"
                                    />

                                }
                            </td>
                            <td className='m-0 p-0 descriptionCol'>
                                {itemData?.eye ?
                                    <input className='p-2' disabled value={row.itemDescription} />
                                    :
                                    <AsyncSelect
                                        className="descSelect"
                                        classNamePrefix="descSelect"
                                        cacheOptions
                                        value={{ value: row.itemDescription, label: row.itemDescription }}
                                        options={descriptionOptions}
                                        loadOptions={loadDescOptions}
                                        onChange={selectedOption => handleInputChange(index, 'itemDescription', selectedOption.label)}
                                        defaultOptions={descriptionOptions}
                                        onMenuScrollToBottom={loadMoreDescOptions}
                                    />
                                }
                            </td>
                            {itemData?.eye ?
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.specification} style={{ width: "130px" }} /></td>
                                :
                                <td className='m-0 p-0'><input className='p-2' style={{ width: "130px" }} type="text" value={row.specification} onChange={e => handleInputChange(index, 'specification', e.target.value)} /></td>
                            }
                            {itemData?.eye ?
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.qty} style={{ width: "100px" }} /></td>
                                :
                                <td className='m-0 p-0'><input className='p-2' onWheel={(e) => e.target.blur()} onKeyDown={preventNegativeSign}
                                    type="number" value={row.qty} style={{ width: "100px" }} onChange={e => handleInputChange(index, 'qty', e.target.value)} /></td>
                            }
                            {itemData?.eye ?
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.uom} style={{ width: "130px" }} /></td>
                                :
                                <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.uom} style={{ width: "130px" }} /></td>
                            }
                            {itemData?.eye ?
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.baseQty} style={{ width: "130px" }} /></td>
                                :
                                <td className='m-0 p-0'><input className='p-2' disabled type="number" style={{ width: "130px" }} value={row.baseQty} /></td>
                            }
                            {itemData?.eye ?
                                <td className='m-0 p-0'><input className='p-2' disabled value={row?.baseAmount} style={{ width: "130px" }} /></td>
                                :
                                <td className='m-0 p-0'><input className='p-2' type="number" onWheel={(e) => e.target.blur()} onKeyDown={preventNegativeSign}
                                    value={row?.baseAmount} style={{ width: "130px" }} onChange={e => handleInputChange(index, 'baseAmount', e.target.value)} /></td>
                            }
                            {itemData?.eye ?
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.amount || 0} style={{ width: "120px" }} /></td>
                                :
                                <td className='m-0 p-0'><input className='p-2' disabled type="text" style={{ width: "120px" }} value={row.amount || 0} /></td>
                            }
                            {itemData?.eye ?
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.stock} style={{ width: "100px" }} /></td>
                                :
                                <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.stock} style={{ width: "100px" }} /></td>
                            }
                            {itemData?.eye ?
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.bol} style={{ width: "130px" }} /></td>
                                :
                                <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.bol} style={{ width: "130px" }} /></td>
                            }
                        </tr>
                    ))}
                </tbody>
            </table>
            {itemData?.eye ? "" :
                <div className='row mt-5'>
                    <div className='col-2'>
                        <button className='mainbtn ' onClick={addNewRow}>
                            <IoAddSharp color='#fff' className='center mt-1 mx-2' /> <div>Add Item</div>
                        </button>
                    </div>
                    {/* <div className=' col-2'>
                        <button className='mainbtn ' onClick={removeLastRow}>
                            Remove
                        </button>
                    </div> */}
                </div>
            }
        </div>
    );
};

export default RequisitionGrid;
